import type { TransformRule, RoutingTarget } from '@/lib/types'

export const RULE_TYPES: TransformRule['type'][] = ['set_field', 'remove_field', 'rename_field', 'add_header', 'remove_header']

export const RULE_TYPE_LABELS: Record<TransformRule['type'], string> = {
  set_field: 'ruleSetField',
  remove_field: 'ruleRemoveField',
  rename_field: 'ruleRenameField',
  add_header: 'ruleAddHeader',
  remove_header: 'ruleRemoveHeader',
}

export const CONDITION_OPTIONS: RoutingTarget['condition'][] = ['all', 'on_success', 'on_failure']

export const CONDITION_LABELS: Record<RoutingTarget['condition'], string> = {
  all: 'conditionAll',
  on_success: 'conditionOnSuccess',
  on_failure: 'conditionOnFailure',
}
